export const SET_PENDING_APPROVALS_COUNT = 'SET_PENDING_APPROVALS_COUNT';

// Keeps the sidebar "Approvals" badge in sync with the number of pending,
// actionable requests for the current user.
export const setPendingApprovalsCount = (count) => ({
  type: SET_PENDING_APPROVALS_COUNT,
  count,
});
